import { InkleFileData } from "components/fileTax/FileCompleteDocuments";
import { LocalFilePreview, Preview } from "components/PreviewModal";

type UnifiedPreviewProps = {
  localPreviewFile: File | null;
  remotePreviewFile: InkleFileData | null;
  groupId?: string;
  closeModal: () => void;
};

export const UnifiedPreview = ({
  localPreviewFile,
  remotePreviewFile,
  groupId,
  closeModal,
}: UnifiedPreviewProps) => {
  if (localPreviewFile) {
    return (
      <LocalFilePreview
        isOpen={Boolean(localPreviewFile)}
        file={localPreviewFile}
        close={closeModal}
      />
    );
  }

  if (remotePreviewFile) {
    return (
      <Preview
        showModal={Boolean(remotePreviewFile)}
        closeModal={closeModal}
        groupId={groupId}
        previewId={remotePreviewFile.uuid}
      />
    );
  }

  return null;
};
